import { Editor } from 'slate'
import type { CustomEditor } from '../custom-types'

export function setTextColor(editor: CustomEditor, color: string | null) {
  if (color === 'inherit') {
    Editor.removeMark(editor, 'color')
  } else {
    Editor.addMark(editor, 'color', color)
  }
}

export function getTextColor(editor: CustomEditor) {
  return Editor.marks(editor)?.color
}
